import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGetJobsFacetsQuery } from '@job-facets/redux/fetchApiSlice';
import PopularTagsView from './View';

function PopularTags() {
	const { data } = useGetJobsFacetsQuery();

	const dispatch = useDispatch();
	const jobTypesAll = data?.facets?.jobListingType.options;
	const slug = data?.facets?.jobListingType?.slug;

	// extract only 6 array items from jobTypes array
	const jobTypes = jobTypesAll?.slice(0, 6);

	const { job_listing_type: preSelecedTags } = useSelector(
		(state) => state.jobsFormInput,
	);

	return (
		<PopularTagsView
			options={jobTypes}
			dispatch={dispatch}
			slug={slug}
			preSelectedTags={preSelecedTags}
		/>
	);
}

export default PopularTags;
